import React, { useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import { withRouter } from 'react-router';
import qs from 'qs';
import { history } from '../../../utils/navigation-util';
import pathConst, { companyReportPath } from '../../../constants/PathsConstant';
import { useQuicksightDashboards } from '../../../hooks/quicksight/useQuicksightDashboards';

const CompanyReportsHeader = (props) => {
  const query = qs.parse(props.location.search, { ignoreQueryPrefix: true });
  const { pid, companyProductSelection } = props;
  if (pid !== undefined) {
    query.pid = pid;
  }

  const compensationOn = Boolean(companyProductSelection?.compensation);
  const { dashboards, loading } = useQuicksightDashboards(compensationOn);

  const navItems = useMemo(() => {
    if (!compensationOn || loading) return [];
    return dashboards.map((d) => ({
      to: companyReportPath(d.dashboardId),
      search: `${pathConst.QUERY_PID}${query.pid}`,
      name: d.name,
      exact: true,
      disabled: false,
    }));
  }, [compensationOn, dashboards, loading, query.pid]);

  if (!compensationOn || loading || navItems.length === 0) {
    return null;
  }

  return (
    <nav className="subnavbar navbar navbar-expand-md navbar-light bg-light">
      <div className="collapse navbar-collapse" id="navbarSupportedContent">
        <ul className="navbar-nav me-auto">
          {navItems.map(({ to, name, exact, search, disabled }, index) => (
            <li
              className="nav-item"
              key={`company-report-nav_${to}`}
              onMouseEnter={() => props.handleHoverSubmenu(to.substr(0, to.lastIndexOf('/')))}
              onMouseLeave={() => props.handleHoverSubmenu('')}
            >
              <NavLink
                to={to + search}
                onClick={(e) => {
                  e.preventDefault();
                  history.push({
                    pathname: to,
                    search,
                    state: { isLoadChildContent: true },
                  });
                  props.handleResetBreadcrumbs(to);
                  props.handleResetCompanyPath(to);
                  props.handleVisitorLog(to, search);
                }}
                className={disabled ? 'nav-link disabled' : 'nav-link'}
                activeClassName={disabled ? '' : 'active'}
                id={`navItem-${name}-${index}`}
                exact={exact}
                isActive={(match, location) => {
                  if (!match) return false;
                  return location.pathname === to;
                }}
              >
                {name}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default withRouter(CompanyReportsHeader);
